interface Actions {
  create?: () => void;
  read?: () => void;
}

export type AIFilterProvider =
  | "google"
  | "openai"
  | "cutout.pro"
  | "built_in_processing"
  | "vertex";

export const AI_FILTER_PROVIDER_LABELS: Record<AIFilterProvider, string> = {
  google: "Google",
  openai: "Open AI",
  "cutout.pro": "Cutout Pro",
  built_in_processing: "Built-in Processing",
  vertex: "Vertex AI",
};

export const getAIFilterProviderLabel = (provider?: string): string => {
  if (!provider) {
    return "";
  }
  if ((provider as AIFilterProvider) in AI_FILTER_PROVIDER_LABELS) {
    return AI_FILTER_PROVIDER_LABELS[provider as AIFilterProvider];
  }
  return provider;
};

export interface AIFilterCategory {
  _id: string;
  parentId?: string;
  ancestorIds: string[];
  name: string;
  createdAt: string;
  updateDAt: string;
  actions?: Actions;
}

export interface AIFilter {
  _id: string;
  categoryId: string;
  fallbackId?: string;
  name: string;
  provider: AIFilterProvider;
  type: string;
  config: Record<string, unknown>;
  referenceImageUrls?: string[] | null;
}
